// Raw-status → StatusPill config. StatusPill owns the pill colours via its
// own key set; this table maps domain proposal statuses onto those keys and
// supplies the labels shared by product rows and dialogs.
export const PILL_MAP: Record<string, { key: string; label: string }> = {
  INVITATION: { key: 'invitation', label: 'Quote Request' },
  OFFERED: { key: 'accepted', label: 'Work Assignment' },
  // A submitted counter awaits staffing, so it uses the warning/amber pill.
  COUNTERED: { key: 'on_hold', label: 'Counter Submitted' },
  // A revised offer is actionable like OFFERED, rather than awaiting staffing.
  RE_OFFERED: { key: 'accepted', label: 'Revised Offer' },
  SUBMITTED: { key: 'accepted', label: 'Submitted' },
  PROPOSAL: { key: 'accepted', label: 'Submitted' },
  QUOTED: { key: 'accepted', label: 'Quoted' },
  BID_WON: { key: 'awarded', label: 'Awarded' },
  BID_LOST: { key: '', label: 'Not Awarded' }, // '' → neutral pill
  NO_RESPONSE: { key: '', label: 'Not Awarded' },
  ACTIVE: { key: 'in_progress', label: 'Authorized' }, // active-teal
  ADDRESSING_COMMENTS: { key: 'on_hold', label: 'Addressing Comments' },
  IN_REVIEW: { key: 'on_hold', label: 'In Review' },
  REVIEW_PENDING: { key: 'on_hold', label: 'Review Pending' },
  REVISION_REQUESTED: { key: 'on_hold', label: 'Revision Requested' },
  REVISION_PENDING: { key: 'on_hold', label: 'Revision Pending' },
  COMPLETED: { key: 'awarded', label: 'Completed' },
  DECLINED: { key: 'declined', label: 'Closed' },
  CANCELLED: { key: 'declined', label: 'Closed' },
};

/** Match known statuses without case sensitivity; preserve unknown wire values. */
export function productStatusLabel(status: string): string {
  return PILL_MAP[status.toUpperCase()]?.label ?? status;
}
